import { useParams } from 'react-router-dom';
import { RegistrationOption } from '../account/RegistrationOption';

function RegistrationOptionWrapper() {
    const { guid } = useParams();
    return <RegistrationOption guid={guid || ''} />;
}

export default RegistrationOptionWrapper;
